import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

export interface ConfirmDeleteDialogProps {
  isOpen: boolean;
  onDismiss: () => void;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmDeleteDialog({
  isOpen,
  onDismiss,
  onCancel,
  onConfirm,
}: ConfirmDeleteDialogProps) {
  return (
    <Modal isOpen={isOpen} onClose={onDismiss}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Are you sure?</ModalHeader>
        <ModalCloseButton title="Close" rounded="sm" />

        <ModalBody>
          <Text>
            Deleting this row cannot be undone. Do you want to proceed? This
            change won't be permanent until you save the form.
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button rounded="sm" mr={3} onClick={onCancel}>
            No, Cancel
          </Button>

          <Button
            variant="solid"
            rounded="sm"
            onClick={onConfirm}
            bg="snap.red.700"
            color="white"
            _hover={{ bg: 'snap.red.800' }}
          >
            Yes, Delete It
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
